import { PayloadAction } from '@reduxjs/toolkit';

import { AuthState } from '../../auth';

export const OFFICE_CONTACT_DATA_REDUCERS = {
  setOfficeContactDataStart(state: AuthState) {
    state.isChangingOfficeContactData = true;
    state.isChangingOfficeContactDataError = false;
  },
  setOfficeContactDataFailed(state: AuthState) {
    state.isChangingOfficeContactDataError = true;
  },
  setOfficeContactDataSuccess(
    state: AuthState,
    action: PayloadAction<{
      contactEmail: string;
      pointOfContact: string;
      contactPhone: string;
    }>
  ) {
    state.isChangingOfficeContactData = false;
    state.isChangingOfficeContactDataError = false;
    if (state.user?.company) {
      state.user.company = {
        ...state.user.company,
        contactEmail: action.payload.contactEmail,
        pointOfContact: action.payload.pointOfContact,
        contactPhone: action.payload.contactPhone,
      };

      const companyId = state.user.company.id;
      if (companyId) {
        state.user.employments = state.user.employments.map((employment) => {
          if (employment.companyId === companyId) {
            return {
              ...employment,
              company: {
                ...employment.company,
                contactEmail: action.payload.contactEmail,
                pointOfContact: action.payload.pointOfContact,
                contactPhone: action.payload.contactPhone,
              },
            };
          }
          return employment;
        });
      }
    }
  },
};
